export const T = {
  en_GB: {
    manageTranslations: "Manage translations",
    translations: "Translations",
    enterTranslationsFor: "Enter translations for",
    translationPlaceholder: "Translation...",
    aiTranslate: "AI Translate",
    translateMissing: "Translate missing",
    translateAll: "Translate all",
    translationFailed: "Translation failed. Please try again.",
    cancel: "Cancel",
    save: "Save",
  },
  nb_NO: {
    manageTranslations: "Administrer oversettelser",
    translations: "Oversettelser",
    enterTranslationsFor: "Skriv inn oversettelser for",
    translationPlaceholder: "Oversettelse...",
    aiTranslate: "KI-oversett",
    translateMissing: "Oversett manglende",
    translateAll: "Oversett alle",
    translationFailed: "Oversettelse mislyktes. Prøv igjen.",
    cancel: "Avbryt",
    save: "Lagre",
  },
} as const;
